import Container from "@vfuk/core-container";
import Icon from "@vfuk/core-icon";
import Heading from "@vfuk/core-heading";
import { Stack } from "@ucchub/ui";
import Button from "@vfuk/core-button";
import { useTranslation } from "react-i18next";
import Spacing from "@vfuk/core-spacing";
import AddProductModal from "./AddProductModal";
import { useState } from "react";
import type { AddProductModalProps } from "./AddProductModal";

type Props = Pick<
  AddProductModalProps,
  "isProductsLoading" | "productList" | "customerId"
>;

const AddProductBlock = ({
  productList,
  isProductsLoading,
  customerId,
}: Props) => {
  const { t } = useTranslation();
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);

  const handleOnCloseAddProductModal = () => {
    setIsAddProductModalOpen(false);
  };

  return (
    <>
      <Spacing
        spacingLevel={{
          top: 3,
          bottom: 3,
        }}
      >
        <Container appearance="primary" elevation>
          <Stack justifyContent="center" direction="column" rowGap="0.5rem">
            <Icon size={4} name="add-ons" />
            <Heading
              level={4}
              weight={2}
              text={t("core:customers:add_product_title") || undefined}
            />
            <Button
              text={t("core:customers:add_product")}
              onClick={() => {
                setIsAddProductModalOpen(true);
              }}
            />
          </Stack>
        </Container>
      </Spacing>
      <AddProductModal
        customerId={customerId}
        isOpen={isAddProductModalOpen}
        productList={productList}
        isProductsLoading={isProductsLoading}
        onClose={handleOnCloseAddProductModal}
      />
    </>
  );
};

export default AddProductBlock;
